<template>
  <div>
    <div class="breadcrumb-div">
      <a-breadcrumb separator="/">
        <a-breadcrumb-item>
          <router-link
            :to="routeNameUrl"
            class="routelink"
          >
            {{ subtitleFirst }}
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          {{ subtitleSecond }}
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <h1 class="title">
      {{ title }}
    </h1>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    routename: {
      type: String,
      default: ''
    },
    subtitleFirst: {
      type: String,
      default: ''
    },
    subtitleSecond: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      routeNameUrl: {
        name: ''
      }
    }
  },
  watch: {
    routename: {
      handler (val) {
        if (!val) return
        this.routeNameUrl.name = val
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.breadcrumb-div {
  margin-top: 16px !important;
  margin-bottom: -16px !important;
  .ant-breadcrumb-link {
    .routelink {
      color: #5077aa !important;
    }
  }
}
</style>
